import {configureStore} from '@reduxjs/toolkit';
import {promiseResolverMiddleware} from '~/common/middleware/promiseResolver';
import {api} from '~/ViewInvitation/api/api';
import {rootReducer} from './reducers';

export const middlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    immutableCheck: false,
    serializableCheck: false,
  }).concat(api.middleware, promiseResolverMiddleware);

export function createInvitationStore(initialState) {
  return configureStore({
    reducer: {
      ...rootReducer,
      [api.reducerPath]: api.reducer,
    },
    preloadedState: initialState,
    middleware: middlewares,
  });
}
